const CustomMapDatasetType = {
	UNKNOWN: "Unknown",
	POINTS: "Points",
	MULTIPOLYGON_GRADIENT: "Multi-Polygon Gradient"
};
export default CustomMapDatasetType;
